module.exports = __webpack_public_path__ + "img/premium_bodyimage02.bc6d4aeb.jpg";